import * as ko from 'knockout';
import * as $ from 'jquery';
import 'jqueryui';
import 'jquery.hotkeys';
import { Application } from "../../services/application";
import { PopupType } from "../../services/popups/popupType";
import { PopupMode } from "../../services/popups/popup";
import { EstimateCostRowPopupParams } from "../estimate-cost-row-popup/estimate-cost-row-popup";
import { ConfirmationPopupParams } from "../confirmation-popup/confirmation-popup";
import { CommandType } from "../../services/commandType";
import { EditorMode } from "../estimate-cost-row-popup/estimate-cost-row-popup";
import { EstimatePrintPopupParams } from "../estimate-print-popup/estimate-print-popup";

export type ShellViewModelParams = {
    app: Application;
}

class ShellViewModel {

    public app = this.params.app;
    
    constructor(private params: ShellViewModelParams) {

        ko.bindingHandlers.resizable = {
            init: function (element, valueAccessor) {
                let options = valueAccessor();
                $(element).resizable(options);
            }
        };

        ko.bindingHandlers.draggable = {
            init: function (element, valueAccessor) {
                let options = valueAccessor();
                $(element).draggable(options);
            }
        };        
        
        ko.bindingHandlers.droppable = {
            init: function (element, valueAccessor) {
                let options = valueAccessor();
                $(element).droppable(options);
            }
        };
        
        ko.components.register('app', require('bundle-loader?lazy!../app/app'));

        ko.components.register('nav-bar', require('bundle-loader?lazy!../nav-bar/nav-bar'));
        ko.components.register('kicked-out-overlay', require('bundle-loader?lazy!../kicked-out-overlay/kicked-out-overlay'));
        ko.components.register('subscription-expired-overlay', require('bundle-loader?lazy!../subscription-expired-overlay/subscription-expired-overlay'));
        ko.components.register('min-width-overlay', require('bundle-loader?lazy!../min-width-overlay/min-width-overlay'));
        ko.components.register('main-menu', require('bundle-loader?lazy!../main-menu/main-menu'));
        ko.components.register('tools-bar', require('bundle-loader?lazy!../tools-bar/tools-bar'));
        ko.components.register('side-bar', require('bundle-loader?lazy!../side-bar/side-bar'));

        ko.components.register('estimate-panel', require('bundle-loader?lazy!../estimate-panel/estimate-panel'));
        ko.components.register('estimate-grid', require('bundle-loader?lazy!../estimate-grid/estimate-grid'));
        ko.components.register('estimates-grid', require('bundle-loader?lazy!../estimates-grid/estimates-grid'));
        ko.components.register('estimates-popup', require('bundle-loader?lazy!../estimates-popup/estimates-popup'));
        ko.components.register('new-estimate-popup', require('bundle-loader?lazy!../new-estimate-popup/new-estimate-popup'));
        ko.components.register('import-estimate-popup', require('bundle-loader?lazy!../import-estimate-popup/import-estimate-popup'));

        ko.components.register('costbook-scrollbar', require('bundle-loader?lazy!../costbook-scrollbar/costbook-scrollbar'));
        ko.components.register('costbook-panel', require('bundle-loader?lazy!../costbook-panel/costbook-panel'));
        ko.components.register('costbook-grid', require('bundle-loader?lazy!../costbook-grid/costbook-grid'));
        ko.components.register('costbook-tabs', require('bundle-loader?lazy!../costbook-tabs/costbook-tabs'));
        ko.components.register('costbooks-grid', require('bundle-loader?lazy!../costbooks-grid/costbooks-grid'));
        ko.components.register('costbooks-popup', require('bundle-loader?lazy!../costbooks-popup/costbooks-popup'));
        ko.components.register('costbook-properties-popup', require('bundle-loader?lazy!../costbook-properties-popup/costbook-properties-popup'));
        ko.components.register('costbook-cost-picker', require('bundle-loader?lazy!../costbook-cost-picker/costbook-cost-picker'));
        
        ko.components.register('customer-info-popup', require('bundle-loader?lazy!../customer-info-popup/customer-info-popup'));
        ko.components.register('company-info-popup', require('bundle-loader?lazy!../company-info-popup/company-info-popup'));
        ko.components.register('job-info-popup', require('bundle-loader?lazy!../job-info-popup/job-info-popup'));
        ko.components.register('accounting-settings-popup', require('bundle-loader?lazy!../accounting-settings-popup/accounting-settings-popup'));
        ko.components.register('qbo-settings-layout', require('bundle-loader?lazy!../qbo-settings-layout/qbo-settings-layout'));
        ko.components.register('excel-settings-layout', require('bundle-loader?lazy!../excel-settings-layout/excel-settings-layout'));
        ko.components.register('qbd-settings-layout', require('bundle-loader?lazy!../qbd-settings-layout/qbd-settings-layout'));
        ko.components.register('qbo-progressive-popup', require('bundle-loader?lazy!../qbo-progressive-popup/qbo-progressive-popup'));
        ko.components.register('tax-rates-popup', require('bundle-loader?lazy!../tax-rates-popup/tax-rates-popup'));
        ko.components.register('markups-popup', require('bundle-loader?lazy!../markups-popup/markups-popup'));
        ko.components.register('percentages-popup', require('bundle-loader?lazy!../percentages-popup/percentages-popup'));
        ko.components.register('area-costs-modifications-popup', require('bundle-loader?lazy!../area-costs-modifications-popup/area-costs-modifications-popup'));
        
        ko.components.register('estimate-text-row-popup', require('bundle-loader?lazy!../estimate-text-row-popup/estimate-text-row-popup'));
        ko.components.register('estimate-cost-row-popup', require('bundle-loader?lazy!../estimate-cost-row-popup/estimate-cost-row-popup'));
        ko.components.register('estimate-subtotal-row-popup', require('bundle-loader?lazy!../estimate-subtotal-row-popup/estimate-subtotal-row-popup'));

        ko.components.register('keyword-search', require('bundle-loader?lazy!../keyword-search/keyword-search'));
        ko.components.register('content-search-bar', require('bundle-loader?lazy!../content-search-bar/content-search-bar'));
        ko.components.register('index-search-bar', require('bundle-loader?lazy!../index-search-bar/index-search-bar'));
        ko.components.register('bookmarks-search-bar', require('bundle-loader?lazy!../bookmarks-search-bar/bookmarks-search-bar'));

        ko.components.register('estimate-rename-popup', require('bundle-loader?lazy!../estimate-rename-popup/estimate-rename-popup'));
        ko.components.register('estimate-save-as-popup', require('bundle-loader?lazy!../estimate-save-as-popup/estimate-save-as-popup'));
        ko.components.register('estimate-delete-popup', require('bundle-loader?lazy!../estimate-delete-popup/estimate-delete-popup'));
        ko.components.register('estimate-qbo-popup', require('bundle-loader?lazy!../estimate-qbo-popup/estimate-qbo-popup'));
        ko.components.register('estimate-import-popup', require('bundle-loader?lazy!../estimate-import-popup/estimate-import-popup'));
        ko.components.register('estimate-export-popup', require('bundle-loader?lazy!../estimate-export-popup/estimate-export-popup'));
        
        ko.components.register('confirmation-popup', require('bundle-loader?lazy!../confirmation-popup/confirmation-popup'));
        ko.components.register('image-popup', require('bundle-loader?lazy!../image-popup/image-popup'));
        ko.components.register('export-bid-popup', require('bundle-loader?lazy!../export-bid-popup/export-bid-popup'));
        ko.components.register('missing-info-popup', require('bundle-loader?lazy!../missing-info-popup/missing-info-popup'));
        ko.components.register('export-invoice-popup', require('bundle-loader?lazy!../export-invoice-popup/export-invoice-popup'));
        ko.components.register('export-settings-layout', require('bundle-loader?lazy!../export-settings-layout/export-settings-layout'));
        ko.components.register('qbo-export-result-popup', require('bundle-loader?lazy!../qbo-export-result-popup/qbo-export-result-popup'));
        ko.components.register('estimate-print-popup', require('bundle-loader?lazy!../estimate-print-popup/estimate-print-popup'));

        this.app.popupsManager.register<{}>(PopupType.newEstimate, "new-estimate-popup");
        this.app.popupsManager.register<{}>(PopupType.importEstimate, "import-estimate-popup");
        this.app.popupsManager.register<{}>(PopupType.estimates, "estimates-popup");
        this.app.popupsManager.register<{}>(PopupType.costbooks, "costbooks-popup");
        this.app.popupsManager.register<{}>(PopupType.costbookProperties, "costbook-properties-popup");
        this.app.popupsManager.register<{}>(PopupType.exportBid, "export-bid-popup");
        this.app.popupsManager.register<{}>(PopupType.missingInfo, "missing-info-popup");
        this.app.popupsManager.register<{}>(PopupType.exportInvoice, "export-invoice-popup");
        this.app.popupsManager.register<{}>(PopupType.qboExportResult, "qbo-export-result-popup");
        this.app.popupsManager.register<{}>(PopupType.customerInfo, "customer-info-popup");
        this.app.popupsManager.register<{}>(PopupType.companyInfo, "company-info-popup");
        this.app.popupsManager.register<{}>(PopupType.estimateQboInfo, "estimate-qbo-popup");
        this.app.popupsManager.register<{}>(PopupType.jobInfo, "job-info-popup");
        this.app.popupsManager.register<{}>(PopupType.accountingSettings, "accounting-settings-popup");
        this.app.popupsManager.register<{}>(PopupType.qboProgressive, "qbo-progressive-popup");
        this.app.popupsManager.register<{}>(PopupType.taxRates, "tax-rates-popup");
        this.app.popupsManager.register<{}>(PopupType.markups, "markups-popup");
        this.app.popupsManager.register<{}>(PopupType.percentages, "percentages-popup");
        this.app.popupsManager.register<{}>(PopupType.areaCostsModifications, "area-costs-modifications-popup");
        this.app.popupsManager.register<{}>(PopupType.costPicker, "costbook-cost-picker");

        this.app.popupsManager.register<{}>(PopupType.estimateRename, "estimate-rename-popup");
        this.app.popupsManager.register<{}>(PopupType.estimateSaveAs, "estimate-save-as-popup");
        this.app.popupsManager.register<{}>(PopupType.deleteEstimate, "estimate-delete-popup");
        this.app.popupsManager.register<{}>(PopupType.estimateImport, "estimate-import-popup");
        this.app.popupsManager.register<{}>(PopupType.estimateExport, "estimate-export-popup");
        
        this.app.popupsManager.register<PopupMode>(PopupType.estimateTextRow, "estimate-text-row-popup");
        this.app.popupsManager.register<PopupMode>(PopupType.estimateSubtotalRow, "estimate-subtotal-row-popup");
        this.app.popupsManager.register<EstimateCostRowPopupParams>(PopupType.estimateCostRow, "estimate-cost-row-popup");
        
        this.app.popupsManager.register<ConfirmationPopupParams>(PopupType.confirmation, "confirmation-popup");
        this.app.popupsManager.register<EstimatePrintPopupParams>(PopupType.printEstimate, "estimate-print-popup");

        this.app.popupsManager.register<{}>(PopupType.image, "image-popup");
        
        this.initShortcuts();
    }
    
    private initShortcuts() {

        this.app.shortcutsManager.initShortcut('alt+n', CommandType.CreateNewEstimate);
        this.app.shortcutsManager.initShortcut('ctrl+o', CommandType.OpenEstimatesPopup);
        this.app.shortcutsManager.initShortcut('f12', CommandType.OpenEstimateSaveAsPopup, this.app.state.estimate());
        this.app.shortcutsManager.initShortcut('ctrl+b', CommandType.OpenCostbooksPopup);
        this.app.shortcutsManager.initShortcut('alt+p', CommandType.PrintEstimate);

        this.app.shortcutsManager.initShortcut('ctrl+x', CommandType.CutRow);
        this.app.shortcutsManager.initShortcut('ctrl+c', CommandType.CopyRow);
        this.app.shortcutsManager.initShortcut('ctrl+e', CommandType.CopyRow, true, CommandType.PasteRow);
        this.app.shortcutsManager.initShortcut('ctrl+v', CommandType.PasteRow);
        this.app.shortcutsManager.initShortcut('ctrl+z', CommandType.Undo);
        this.app.shortcutsManager.initShortcut('ctrl+y', CommandType.Redo);
        
        this.app.shortcutsManager.initShortcut('ctrl+f', CommandType.ShowSearchBar);
        this.app.shortcutsManager.initShortcut('ctrl+s', CommandType.ShowContentSearchBar);
        this.app.shortcutsManager.initShortcut('ctrl+i', CommandType.ShowIndexSearchBar);
        this.app.shortcutsManager.initShortcut('ctrl+k', CommandType.ShowBookmarksSearchBar);
        
        this.app.shortcutsManager.initShortcut('shift+f7', CommandType.OpenMarkupsPopup);

        this.app.shortcutsManager.initShortcut('ctrl+l', CommandType.CreateEstimateTextRow, {
            editorMode: EditorMode.Simple,
            insertAbove: false,
            fromCostbook: false
        });
        this.app.shortcutsManager.initShortcut('f7', CommandType.CreateEstimateCostRow, {
            editorMode: EditorMode.Simple,
            insertAbove: false,
            fromCostbook: false
        });
        this.app.shortcutsManager.initShortcut('f6', CommandType.CreateEstimateSubtotalRow, {
            editorMode: EditorMode.Simple,
            insertAbove: false,
            fromCostbook: false
        });

        this.app.shortcutsManager.initShortcut('f3', CommandType.EditEstimateRow, { editorMode: EditorMode.Simple });

        this.app.shortcutsManager.initShortcut('ctrl+r', CommandType.OpenPercentagesPopup);
        this.app.shortcutsManager.initShortcut('del', CommandType.RemoveEstimateRow);

        this.app.shortcutsManager.initShortcut('ctrl+u', CommandType.ShowEstimateUnitCosts);
        this.app.shortcutsManager.initShortcut('ctrl+d', CommandType.ShowEstimateDoubleSpaceLines);
        this.app.shortcutsManager.initShortcut('ctrl+h', CommandType.HideEstimateComponentCosts);
    }

    // To support hot module replacement, this method unregisters the router and KO components.
    // In production scenarios where hot module replacement is disabled, this would not be invoked.
    public dispose() {
        Object.getOwnPropertyNames((<any>ko).components._allRegisteredComponents).forEach(componentName => {
            ko.components.unregister(componentName);
        });
    }
}

export default {
    viewModel: ShellViewModel,
    template: require('./shell.html')
};



// WEBPACK FOOTER //
// ./ClientApp/components/shell/shell.ts